export const TRACK_EVENT_NAME = "Bulk edit tags";
